import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcherFactory } from '@dataroom/json-rpc-dispatcher';
import DITypes from '@dataroom/json-rpc-dispatcher/DITypes';

@injectable()
class DataroomAccessRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcherFactory,
  ) {}

  checkDataroomAccess = async (
    payload: {
      dataroomId: number,
    },
  ): Promise<boolean> => {
    const request = new Request('dataroom.access_check', payload);
    const response = await this.rpc()
      .call<RpcSuccess>(request);

    return response.getResult();
  };

  canFollow = async (
    payload: {
      dataroomId: number,
    },
  ): Promise<boolean> => {
    const request = new Request('dataroom.can_follow', payload);
    const response = await this.rpc()
      .call<RpcSuccess>(request);

    return response.getResult() as any;
  };

  canRequestAccess = async (
    payload: {
      dataroomId: number,
    },
  ): Promise<{ allowance: 'accessDenied' | 'requestAllowed' }> => {
    const request = new Request('dataroom.can_request_access', payload);
    const response = await this.rpc()
      .call<RpcSuccess>(request);

    return response.getResult().payload;
  };
}

export default DataroomAccessRepository;
